"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
// import { crokinoleBackground } from '@crokinole/background/crokinoleBackground-sidecar'
// import { crokinoleGamepadCursors } from '@crokinole/cursors/crokinoleGamepadCursors-sidecar'
// import { crokinoleMultiplayerCursors } from '@crokinole/cursors/crokinoleMultiplayerCursors-sidecar'
// import { crokinoleGameManager } from '@crokinole/main/crokinoleGameManager-sidecar'
// import { crokinoleSimulationManager } from '@crokinole/main/crokinoleSimulationManager-sidecar'
// import { crokinoleMenuCreator } from '@crokinole/to-engine/crokinoleMenuCreator-sidecar'
// import { crokinoleUi_clickToFocus } from '@crokinole/ui/crokinoleUi_clickToFocus-sidecar'
// import { crokinoleUi_multiplayerDebug } from '@crokinole/ui/crokinoleUi_multiplayerDebug-sidecar'
// import { crokinoleUi_multiplayerStatus } from '@crokinole/ui/crokinoleUi_multiplayerStatus-sidecar'
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var diveUi_messages_sidecar_1 = require("@dive/ui/diveUi_messages-sidecar");
// import { crokinoleBoard } from 'proto/crokinole/board/crokinoleBoard-sidecar'
// import { crokinoleGamepad } from 'proto/crokinole/input/crokinoleGamepad-sidecar'
// import { physics_rapier_loader } from 'proto/crokinole/physics/physics_rapier_loader-sidecar'
// import { crokinoleUi_turnInfo } from 'proto/crokinole/ui/crokinoleUi_turnInfo-sidecar'
// import { crokinoleUi_menu_main } from '../../crokinole/ui-menus/crokinoleUi_menu_main-sidecar'
// import { crokinoleDefs } from '@crokinole/main/crokinoleDefs-sidecar'
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfGamepad_sidecar_1 = require("../input/minigolfGamepad-sidecar");
// import { minigolfGameManager } from '../simulation/minigolfGameManager-sidecar'
// import { minigolfSimulationManager } from '../simulation/minigolfSimulationManager-sidecar'
var minigolfFloatingTexts_sidecar_1 = require("../entities/minigolfFloatingTexts-sidecar");
var battlescapeRenderer_sidecar_1 = require("../levelgen/battlescapeRenderer-sidecar");
var minigolfRenderer_sidecar_1 = require("../renderer/minigolfRenderer-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var camera_moverKeyboard_sidecar_1 = require("../to-engine/camera_moverKeyboard-sidecar");
var camera_moverRightMouse_sidecar_1 = require("../to-engine/camera_moverRightMouse-sidecar");
var generatorManager_sidecar_1 = require("../to-engine/generatorManager-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var minigolfUi_clickToFocus_sidecar_1 = require("../ui/minigolfUi_clickToFocus-sidecar");
var minigolfUi_stats_sidecar_1 = require("../ui/minigolfUi_stats-sidecar");
var update = function (time, delta) {
    // let ctx = goatScene.getContext()
    common_sidecar_1.common.setUpdateDelta(delta / 1000);
    var curSpeedScale = 1;
    common_sidecar_1.common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale);
    if (common_sidecar_1.common.updateFocus()) {
        // Focus changed
        clickEater_sidecar_1.clickEater.tempEat();
    }
    imageRecycler_sidecar_1.imageRecycler.resetAll();
    // minigolfSimulationManager.update()
    // minigolfGameManager.update()
    minigolfGamepad_sidecar_1.minigolfGamepad.updateGamepad();
    physicsTickManager_sidecar_1.physicsTickManager.update();
    generatorManager_sidecar_1.generatorManager.update();
    minigolfCamera_sidecar_1.minigolfCamera.update(function (cam) {
        camera_moverRightMouse_sidecar_1.camera_moverRightMouse.update(cam);
        camera_moverKeyboard_sidecar_1.camera_moverKeyboard.update(cam);
    });
    var map = minigolfGameState_sidecar_1.minigolfGameState.get().map;
    if (map) {
        battlescapeRenderer_sidecar_1.battlescapeRenderer.render(map);
    }
    minigolfRenderer_sidecar_1.minigolfRenderer.render();
    minigolfFloatingTexts_sidecar_1.minigolfFloatingTexts.updateAll();
    // crokinoleMultiplayerCursors.updateAll()
    // crokinoleUi_multiplayerStatus.render()
    // crokinoleUi_multiplayerDebug.update()
    stevieTexts2_sidecar_1.stevieTexts2.updateAll();
    clickEater_sidecar_1.clickEater.updateAll();
    diveUi_messages_sidecar_1.diveUi_messages.drawAll();
    uiFps_sidecar_1.uiFps.update(function (fps) {
        var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
        diveFont_sidecar_1.diveFont.writeAbsolute(gb.width - 30, gb.height - 8, '' + fps, 0.5, diveColors_1.diveColors.pureWhite);
    });
    // crokinoleUi_menu_main.update()
    // diveUi_messagesRecent.open()
    // diveUi_messagesRecent.drawAll()
    // crokinoleGamepadCursors.updateAll()
    // websockets.update()
    // --- SPYDERS
    // if (diveDebug.debug_runSpyders) {
    // diveSpyderTilemap.checkObjectsAndCrewLinks()
    // }
    // crokinoleBackground.update()
    // if (minigolfPhysics_rapier_loader.isLoaded()) {
    //   // crokinoleBoard.update()
    //   minigolfPhysics_rapier_loader.updatePhysics_localhost(
    //     common.getUpdateDelta(),
    //   )
    //   // crokinoleUi_turnInfo.open()
    //   // crokinoleUi_turnInfo.drawAll()
    // }
    // --- MENUS
    // crokinoleMenuCreator.update()
    // crokinoleMenuCreator.render()
    // crokinoleMenuCreator.clear()
    // if (minigolfDefs.proto_showGeoscape) {
    //   geoscapeDemo.run()
    // }
    // if (minigolfDefs.proto_showBattlescape) {
    //   battlescapeDemo.run()
    // }
    minigolfUi_stats_sidecar_1.minigolfUi_stats.render();
    rogueGlyphs_sidecar_1.rogueGlyphs.drawAll();
    minigolfUi_clickToFocus_sidecar_1.minigolfUi_clickToFocus.update();
};
exports.update = update;
